/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, reatomBoolean } from '@reatom/framework'

import { referralCodeAtom } from '@root/entities/referral'

export const createReferralCodeDialogOpenAtom = reatomBoolean(
  false,
  'createReferralCodeDialogOpenAtom',
)
export const changeReferralCodeDialogOpenAtom = reatomBoolean(
  false,
  'changeReferralCodeDialogOpenAtom',
)
export const inviteReferralDialogOpenAtom = atom(
  false,
  'inviteReferralDialogOpenAtom',
)
export const referralWithdrawDialogOpenAtom = atom(
  false,
  'referralWithdrawDialogOpenAtom',
)

export const openReferralWithdrawFlowEvent = action((ctx) => {
  referralWithdrawDialogOpenAtom(ctx, true)
}, 'openReferralWithdrawFlow')

export const openCreateReferralCodeDialogAction = action((ctx) => {
  createReferralCodeDialogOpenAtom.setTrue(ctx)
}, 'openCreateReferralCodeDialog')

export const openChangeReferralCodeDialogAction = action((ctx) => {
  changeReferralCodeDialogOpenAtom.setTrue(ctx)
}, 'openChangeReferralCodeDialog')

export const openInviteReferralDialogAction = action((ctx) => {
  const referralCode = ctx.get(referralCodeAtom)

  if (!referralCode) {
    openCreateReferralCodeDialogAction(ctx)
    return
  }

  inviteReferralDialogOpenAtom(ctx, true)
}, 'openInviteReferralDialog')
